export enum SortingOrders {
  ASC = 1,
  DESC = -1,
}
